import { withFormik } from "formik";
import { compose } from "@reduxjs/toolkit";
import mapPropsToValues from "./mapPropsToValues";
import validationSchema from "./validationSchema";
import { BrandComplianceFormValues } from "interfaces/BrandCompliance";
import BrandComplianceForm from "./BrandComplianceForm";
import { withAction } from "HOCs/withAction";
import { setNotification } from "../../services";

export const BrandComplianceFormContainer = compose(
  withAction((props: any) => setNotification(props), "setNotification"),
  withFormik<{}, BrandComplianceFormValues>({
    mapPropsToValues,
    validationSchema,
    handleSubmit: () => null,
    enableReinitialize: true,
    validateOnMount: true,
  })
)(BrandComplianceForm);

export default BrandComplianceFormContainer;
